
import LLMPromptInput from "../../components/llm-prompt-input/llm-prompt-input";

const ExpandedPromptBody = () => {
  return <LLMPromptInput isExpanded={true} />;
};

export default ExpandedPromptBody;
